/**
 * Algolia Request Counter
 * Intercepts fetch/XHR to count requests to *.algolia.net
 * Must be loaded BEFORE Algolia SDK scripts.
 *
 * Activate via URL parameter: ?debug=algolia
 * Or set window.__ALGOLIA_DEBUG__ = true before this script loads.
 *
 * Exposes:
 * - window.__ALGOLIA_REQUEST_LOG__: Array of request entries
 * - window.__ALGOLIA_COUNTER__: { total, cacheHits, cacheMisses, reset() }
 */
(function () {

  var params = new URLSearchParams(window.location.search);

  // Only activate with ?debug or explicit flag
  var debugEnabled = window.__ALGOLIA_DEBUG__ || params.has('debug');
  if (!debugEnabled) return;

  // -- Proxy redirect: rewrite algolia.net requests to local proxy --
  var proxyPort = params.get('proxy');
  if (proxyPort) {
    window.__ALGOLIA_PROXY_PORT__ = proxyPort;
  }

  var log = [];
  var counter = { total: 0, cacheHits: 0, cacheMisses: 0 };

  window.__ALGOLIA_REQUEST_LOG__ = log;
  window.__ALGOLIA_COUNTER__ = {
    get total() { return counter.total; },
    get cacheHits() { return counter.cacheHits; },
    get cacheMisses() { return counter.cacheMisses; },
    reset: function () {
      log.length = 0;
      counter.total = 0;
      counter.cacheHits = 0;
      counter.cacheMisses = 0;
      updateOverlay();
    }
  };

  function isAlgoliaUrl(url) {
    return typeof url === 'string' && (
      url.indexOf('algolia.net') !== -1 ||
      url.indexOf('algolianet.com') !== -1
    );
  }

  function parseSubQueryCount(body) {
    if (!body) return 1;
    try {
      var parsed = JSON.parse(body);
      if (parsed && Array.isArray(parsed.requests)) {
        return parsed.requests.length;
      }
    } catch (e) { /* not JSON */ }
    return 1;
  }

  function recordRequest(url, method, body, source) {
    var entry = {
      timestamp: Date.now(),
      url: url,
      method: method || 'POST',
      subQueries: parseSubQueryCount(body),
      source: source
    };
    log.push(entry);
    counter.total++;
    counter.cacheMisses++;
    updateOverlay();
  }

  // -- Record cache hit (called externally by cache wrapper) --
  window.__ALGOLIA_RECORD_CACHE_HIT__ = function () {
    counter.cacheHits++;
    updateOverlay();
  };

  // -- Rewrite Algolia URL to proxy --
  function rewriteToProxy(url) {
    if (!proxyPort || !isAlgoliaUrl(url)) return url;
    // https://APPID-dsn.algolia.net/1/indexes/*/queries?... → http://127.0.0.1:PORT/1/indexes/*/queries?...
    try {
      var parsed = new URL(url);
      return 'http://127.0.0.1:' + proxyPort + parsed.pathname + parsed.search;
    } catch (e) { return url; }
  }

  // -- Intercept fetch --
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (isAlgoliaUrl(url)) {
        var body = (init && init.body) || '';
        recordRequest(url, (init && init.method) || 'POST', body, 'fetch');
        var proxiedUrl = rewriteToProxy(url);
        if (proxiedUrl !== url) {
          if (typeof input === 'string') {
            return originalFetch.call(this, proxiedUrl, init);
          }
          return originalFetch.call(this, new Request(proxiedUrl, input), init);
        }
      }
      return originalFetch.apply(this, arguments);
    };
  }

  // -- Intercept XMLHttpRequest --
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__algolia_url__ = url;
    this.__algolia_method__ = method;
    // Rewrite URL to proxy if enabled
    var proxiedUrl = rewriteToProxy(url);
    return originalOpen.call(this, method, proxiedUrl);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (isAlgoliaUrl(this.__algolia_url__)) {
      recordRequest(this.__algolia_url__, this.__algolia_method__, body, 'xhr');
    }
    return originalSend.apply(this, arguments);
  };

  // -- Floating Overlay UI --
  function createOverlay() {
    var el = document.createElement('div');
    el.id = 'algolia-counter-overlay';
    el.style.cssText = [
      'position:fixed', 'bottom:16px', 'right:16px', 'z-index:99999',
      'background:#1a1a2e', 'color:#e0e0e0', 'padding:12px 16px',
      'border-radius:8px', 'font-family:monospace', 'font-size:12px',
      'box-shadow:0 4px 12px rgba(0,0,0,0.3)', 'min-width:220px',
      'cursor:move', 'user-select:none'
    ].join(';');

    el.innerHTML = [
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">',
      '<strong style="color:#5468ff">Algolia Counter</strong>',
      '<button id="algolia-counter-reset" style="background:#333;color:#fff;border:none;',
      'border-radius:4px;padding:2px 8px;cursor:pointer;font-size:11px">Reset</button>',
      '</div>',
      '<div id="algolia-counter-body"></div>'
    ].join('');

    document.body.appendChild(el);

    // Reset button
    document.getElementById('algolia-counter-reset').addEventListener('click', function () {
      window.__ALGOLIA_COUNTER__.reset();
    });

    // Draggable
    var isDragging = false, offsetX, offsetY;
    el.addEventListener('mousedown', function (e) {
      if (e.target.tagName === 'BUTTON') return;
      isDragging = true;
      offsetX = e.clientX - el.getBoundingClientRect().left;
      offsetY = e.clientY - el.getBoundingClientRect().top;
    });
    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      el.style.left = (e.clientX - offsetX) + 'px';
      el.style.top = (e.clientY - offsetY) + 'px';
      el.style.right = 'auto';
      el.style.bottom = 'auto';
    });
    document.addEventListener('mouseup', function () { isDragging = false; });

    return el;
  }

  function updateOverlay() {
    var body = document.getElementById('algolia-counter-body');
    if (!body) return;

    var totalSubQueries = log.reduce(function (sum, e) { return sum + e.subQueries; }, 0);

    body.innerHTML = [
      '<div style="display:grid;grid-template-columns:auto 1fr;gap:2px 12px">',
      '<span style="color:#888">HTTP Requests:</span>',
      '<span style="color:#ff6b6b;font-weight:bold">' + counter.total + '</span>',
      '<span style="color:#888">Sub-queries:</span>',
      '<span>' + totalSubQueries + '</span>',
      '<span style="color:#888">Cache HITs:</span>',
      '<span style="color:#51cf66">' + counter.cacheHits + '</span>',
      '<span style="color:#888">Cache MISSes:</span>',
      '<span style="color:#ffa94d">' + counter.cacheMisses + '</span>',
      '</div>'
    ].join('');
  }

  // Initialize overlay when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      createOverlay();
      updateOverlay();
    });
  } else {
    createOverlay();
    updateOverlay();
  }
})();
